// @flow

import React from 'react';
import styled from 'styled-components';

import type { Element } from 'react';

type Props = {
  title: string | Element<any>,
  description?: string | Element<any>,
};

const Wrapper = styled.div``;

const Heading = styled.h1`
  margin-bottom: 8px;
  font-size: 36px;
  font-weight: bold;
`;

const Description = styled.p`
  opacity: 0.55;
  margin: 0;
`;

const PageHeader = (props: Props) => (
  <Wrapper>
    <Heading>{props.title}</Heading>
    {props.description && <Description>{props.description}</Description>}
  </Wrapper>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js